<template>
  <div class="FinalResult">
    <Logo />
    <!-- <div class="retryButton" @click="restart">
      <span>{{ locale.RETRY }}</span>
      <img src="@/assets/images/retry_icon.png" alt="Retry Icon">
    </div> -->
    <div class="content">
      <div class="heading">
        <LottieWrapper :options="options" :size="size" ref="Lottie_LevelHeader" :completeHandler="null" />
        <AchievementIndicator :totalPossibleSucceses="totalPossibleSucceses" :successfulHits="successfulHits"/>
      </div>
      <div class="play-again" ref="playAgain" @click="toggleModal">
          <img src="@/assets/images/dot_ring_large.png" alt="">
          <h2 v-html="locale.PLAY_AGAIN"></h2>
      </div>
      <div :class="[{ active: isModalVisible }, 'modal']" ref="modal">
          <div class="inner">
              <div class="close-icon" @click="toggleModal">
                  <span>
                      <svg x="0px" y="0px" viewBox="0 0 409.806 409.806" xml:space="preserve">
                    	<g>
                    		<path d="M228.929,205.01L404.596,29.343c6.78-6.548,6.968-17.352,0.42-24.132c-6.548-6.78-17.352-6.968-24.132-0.42    c-0.142,0.137-0.282,0.277-0.42,0.42L204.796,180.878L29.129,5.21c-6.78-6.548-17.584-6.36-24.132,0.42    c-6.388,6.614-6.388,17.099,0,23.713L180.664,205.01L4.997,380.677c-6.663,6.664-6.663,17.468,0,24.132    c6.664,6.662,17.468,6.662,24.132,0l175.667-175.667l175.667,175.667c6.78,6.548,17.584,6.36,24.132-0.42    c6.387-6.614,6.387-17.099,0-23.712L228.929,205.01z"/>
                    	</g>
                    </svg>
                </span>
              </div>
              <p>{{ locale.MODAL_COPY }}</p>
              <div class="btn learn-more"><a :href="locale.LEARN_MORE_LINK" target="_blank" rel="noopener noreferrer">{{ locale.LEARN_MORE_TEXT }}</a></div>
              <div class="btn learn-more" @click="restart">{{ locale.RETRY }}</div>
          </div>
      </div>
      <!-- <div class="messaging">
        <p><SplittingText :outDirection="2" :text="locale.FINAL_RESULT_SUBTITLE" ref="SplittingText_1" /></p>
        <p><SplittingText :outDirection="2" :text="locale.FINAL_RESULT_MESSAGING" ref="SplittingText_2" /></p>
        <div class="learnMore" ref="learnMoreButton">
          <img src="@/assets/images/learn_more_bg.png" alt="Learn More Background">
          <a :href="locale.LEARN_MORE_LINK" target="_blank" rel="noopener noreferrer">
            <span>{{ locale.LEARN_MORE_TEXT }}
              <svg viewBox="0 0 32 32" class="icon icon-chevron-right">
                <path d="M18.629 15.997l-7.083-7.081L13.462 7l8.997 8.997L13.457 25l-1.916-1.916z"/>
              </svg>
            </span>
          </a>
        </div>
      </div> -->
      <div class="rgc" ref="rgc">
        <p class="rgcCopy">{{ locale.RGC_MESSAGING }}</p>
        <img class="rgcLogo" src="@/assets/images/rgc_logo.png" alt="RGC Logo">
      </div>
    </div>
  </div>
</template>

<script>

import { CONFIG } from '@/config'
import { levelFlickerAudio, idleAudio } from '@/audio'

import Logo from '@/components/Logo.vue'
import LottieWrapper from '@/components/LottieWrapper'
import AchievementIndicator from '@/components/AchievementIndicator.vue'
import SplittingText from '@/components/SplittingText'

import { SVGS } from '@/assets/svgs/locale_map'

import { TimelineLite, Expo, TweenLite, TweenMax } from 'gsap'

export default {
  name: 'FinalResult',
  props: {},
  components: {
    Logo,
    LottieWrapper,
    AchievementIndicator,
    SplittingText
  },
  data() {
    this.svgs = SVGS[ this.$store.state.lang.LOCALE ]

    return {
      sessionId: this.$store.state.sessionId,
      size: {
        width: 540,
        height: 100
      },
      options: {
        animationData: this.svgs.FinalScore.default,
        autoplay: false,
        loop: false
      },
      isModalVisible: false,
    }
  },
  mounted() {

    this.initIdleStates()
    this.createAnimationTimeline()

    this.$store.commit( 'setIsIdleLoopPlaying', { isIdleLoopPlaying: true } )
    this.$store.commit( 'setBackgroundVideoState', { isBackgroundVideoPlaying: !this.isMobile } )
    this.$store.commit( 'setHeaderVisibility', { isHeaderVisible: false } )

    const { dot, dial, grid } = CONFIG.videoData
    const { gsr } = this.$store.state

    const totalTimePlay = dot.length + dial.length + grid.length
    const totalSecondsExcited = Math.round( ( gsr.dot.totalSeconds + gsr.dial.totalSeconds + gsr.grid.totalSeconds ) / 100 )

    this.popupTimeout = setTimeout(() => {
        if ( !this.isModalVisible ) this.toggleModal()
    }, 5000)
  },
  beforeRouteLeave( to, from, next ) {
    this.$store.commit( 'setTransitionVisibility', { isTransitionVisible: true } )
    this.$store.commit( 'setBackgroundVideoState', { isBackgroundVideoPlaying: !this.isMobile } )

    clearTimeout( this.popupTimeout )

    setTimeout( () => {
        next()
    }, 250 )
  },
  computed: {
    locale() { return this.$store.state.lang },
    isMobile() { return this.$store.state.isMobile },
    successfulHits() {
      const { dot, dial, grid } = this.$store.state.scores

      return dot + dial + grid
    },
    totalPossibleSucceses() {
      const { dot, dial, grid } = CONFIG.videoData

      return dot.totalTargets + dial.totalTargets + grid.totalTargets
    }
  },
  methods: {
    toggleModal() {
        this.isModalVisible = !this.isModalVisible
        if ( this.isModalVisible ) {
            TweenMax.to( this.$refs.modal, 0.6, { autoAlpha: 1, y: '0%', ease: Expo.easeOut } )
        } else {
            TweenMax.to( this.$refs.modal, 0.6, { autoAlpha: 0, y: '20%', ease: Expo.easeOut } )
        }
    },
    restart() {
      this.$store.commit( 'resetSession' )

      this.$router.push( { name: 'landing', query: { lang: this.locale.LOCALE } } )
    },
    initIdleStates() {
      // TweenLite.set( this.$refs.learnMoreButton, { autoAlpha: 0, y: '20%' } )
      TweenLite.set( this.$refs.rgc, { autoAlpha: 0, y: '20%' } )
      TweenLite.set( this.$refs.playAgain, { autoAlpha: 0, y: '20%' } )
      TweenLite.set( this.$refs.modal, { autoAlpha: 0, y: '20%' } )

    },
    createAnimationTimeline() {
      // const { Lottie_LevelHeader, SplittingText_1, SplittingText_2, learnMoreButton, rgc } = this.$refs
      const { Lottie_LevelHeader, playAgain, rgc, modal } = this.$refs

      this.animateHeadingsIn = new TimelineLite( {  } )

      this.animateHeadingsIn
        .add( () => { Lottie_LevelHeader.play() }, 0.6 )
        .add( () => { levelFlickerAudio.play() }, 0.6 )
        // .add( () => { SplittingText_1.animateTextIn() }, 0.6 )
        // .add( () => { SplittingText_2.animateTextIn() }, 0.6 )
        // .to( learnMoreButton, 1, { autoAlpha: 1, y: '0%', ease: Expo.easeOut }, 0.75 )
        .to( playAgain, 1.2, { autoAlpha: 1, y: '0%', ease: Expo.easeOut }, 0.75 )
        .to( rgc, 1.2, { autoAlpha: 1, y: '0%', ease: Expo.easeOut }, 1 )

      this.animateRouteChange = new TimelineLite( { paused: true } )

      this.animateRouteChange
        .add( () => { this.$store.commit( 'setTransitionVisibility', { isTransitionVisible: true } ) }, 0 )
        .add( () => { this.$router.push( { name: 'landing', query: { lang: this.locale.LOCALE } } ) }, 0.6 )
    }
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .FinalResult {

    height: 100%;
    width: 100%;

    min-height: $page-min-height;

    @include breakpoint( mobile-all ) {

      min-height: 100%;
      overflow: scroll;

      background-image: url('~@/assets/images/bg_poster.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;

    }

    .modal {
        position: fixed;
        width: 65%;
        max-width: rem( 800 );

        padding: rem( 20 );

        background: #ffffffde;
        border-radius: rem( 10 );
        color: $color-navy;

        box-shadow: 0 rem( 3 ) rem( 5 ) rem( 5 ) #00000040;

        @include breakpoint( mobile-all ) {
            width: 85%;
        }

        .inner {
            padding: rem( 20 );
            border-radius: rem( 10 );
            border: solid rem( 1 ) $color-navy;

            @include breakpoint( mobile-all ) {
                padding: rem( 10 );
            }

            p {
                max-width: rem( 560 );

                margin: rem( 20 ) auto;

                font-size: rem( 22 );
                line-height: 1.5;

                @include breakpoint( mobile-all ) {
                    font-size: rem( 14 );
                }
            }
        }

        .close-icon {
            width: rem( 40 );
            margin-left: auto;
            text-align: center;
            cursor: pointer;

            svg {
                width: rem( 20 );
            }
        }

        .btn {
            display: inline-flex;

            padding: rem( 8 ) rem( 20 );
            margin: rem( 20 ) rem( 10 );

            border-radius: rem( 8 );

            color: $color-white;
            background: $color-navy;

            font-size: rem( 14 );
            font-weight: 700;
            letter-spacing: rem( 1 );
            text-transform: uppercase;

            cursor: pointer;

            a { text-decoration: none }
        }
    }

    .play-again {
        position: relative;

        display: flex;
        justify-content: center;
        align-items: center;

        cursor: pointer;

        img {
            width: rem( 320 );
            margin: rem( -40 ) 0;

            @include breakpoint( mobile-all ) {
                width: rem( 220 );
                max-width: 100%;
            }

        }

        h2 {
            position: absolute;

            color: $color-navy;

            text-transform: uppercase;

            font-size: rem( 32 );
            font-weight: 700;
            font-style: italic;

            margin: 0;

            @include breakpoint( mobile-all ) {

                font-size: rem( 30 );
            }
        }
    }

    // @include breakpoint-width( 375px, 667px ) {
    //
    //   overflow: scroll;
    //
    // }

    .Logo {

      position: absolute;
      top: rem( 40 );
      left: 0;
      right: 0;

      margin: 0 auto;

      @include breakpoint( mobile-all ) {

        position: relative;
        top: rem( 40 );

      }

    }

    .LottieWrapper {

      max-width: rem( 400 );
      width: 100%;

      margin: rem( 100 ) auto 0;

    }

    .retryButton {

      position: absolute;
      right: rem( 30 );
      top: rem( 30 );

      display: flex;
      align-items: center;

      cursor: pointer;

      @include breakpoint( mobile-all ) {

        top: rem( 20 );
        right: rem( 10 );

      }

      span {

        display: block;
        margin-right: rem( 5 );
        color: $color-turquoise;
        font-size: $font-primary-size-heading3;

        @include breakpoint( mobile-all ) {

          font-size: rem( 16 );
          margin-right: rem( 2 );

        }

      }

      img {

        width: rem( 60 );
        height: rem( 60 );

        @include breakpoint( mobile-all ) {

          width: rem( 40 );
          height: rem( 40 );

        }

      }

    }

    .content {

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      height: 100%;
      width: 100%;

      .messaging p {

        @include lowecaseText();

        max-width: 55%;
        margin: 0 auto rem( 20 );

        @include breakpoint( mobile-all ) {

          max-width: 82%;

        }

        &:nth-of-type(1) {

          text-transform: uppercase;
          font-weight: 700;
          margin: 0 auto rem( 10 );

        }

        &:nth-of-type(2) {

          color: $color-white;
        }

        & > span {

          text-shadow: 0 0 rem( 4 ) $color-turquoise;

        }

        // span[data-word="Enter"] {
        //   border: solid 2px red;
        // }

      }

    }

    .rgc {

      margin-bottom: rem( 60 );

      @include breakpoint( mobile-all ) {

        margin-bottom: rem( 20 );

      }

      img {

        max-width: rem( 60 );
        max-height: rem( 60 );

        @include breakpoint( mobile-all ) {

          max-width: rem( 80 );
          max-height: rem( 80 );

        }

      }

      .rgcCopy {

        font-size: rem( 12 );
        color: $color-white;
        opacity: 0.5;

        margin: rem( 100 ) auto rem( 10 );
        max-width: 60%;

        @include breakpoint( mobile-all ) {

          font-size: rem( 12 );
          margin: rem( 60 ) auto rem( 10 );
          max-width: 90%;

        }

        @include breakpoint-width( 375px, 667px ) {

          margin: rem( 20 ) auto rem( 10 );
          max-width: 90%;

        }

      }

    }

    .learnMore {

      position: relative;

      width: rem( 280 );
      height: rem( 60 );

      display: flex;
      justify-content: center;
      align-items: center;

      margin: 0 auto;

      cursor: pointer;

      @include uppercaseText();

      font-weight: 700;
      color: $color-turquoise;

      @include breakpoint( mobile-all ) {

        width: rem( 270 );
        height: rem( 60 );

      }

      img {

        width: 100%;
        height: 100%;

        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;

      }

      a {
        text-decoration: none;

        span {

          display: flex;
          justify-content: center;
          align-items: center;

          svg {

            fill: $color-turquoise;
            width: rem( 40 );
            height: rem( 40 );

            @include breakpoint( mobile-all ) {

              width: rem( 15 );
              height: rem( 15 );

            }

          }

        }

      }

    }

  }

</style>

<style lang="scss">

@import '@/styles/core.scss';

.FinalResult {

  span[data-word="Enter"] {
    text-decoration: underline;
  }

  .AchievementIndicator {

    padding: rem( 0 ) 0 rem( 40 );

    @include breakpoint( mobile-all ) {

      padding: rem( 0 ) 0 rem( 40 );

    }

    @include breakpoint-width( 375px, 667px ) {

      padding: rem( 0 ) 0 rem( 10 );

    }

    h4, h3 {

      display: none;

    }

  }

}

</style>
